
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import ChaletIcon from '@mui/icons-material/Chalet';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import TtkList from './TtkList';
 

const BirthadayClubingTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Start of Venue	:</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p><DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Parking:</b>&nbsp;<TtkList data={data?.parking} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Car Parking Space :</b>&nbsp;<span>{data?.parkingSize}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> &nbsp;<b>Veg Price Per Plate</b>&nbsp;&#8377;&nbsp;<span>{data?.vegPrice} </span></p>
                        </div>


                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p> &nbsp;<b>Non-Veg Price Per Plate :</b>&nbsp;&#8377;&nbsp;<span>{data?.nonVegPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p><DonutSmallIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Small Party Venue:</b>&nbsp;<TtkList data={data?.smallPartiesVenue} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Space:</b>&nbsp;<TtkList data={data?.space} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Room Counts :</b>&nbsp;<span>{data?.roomCount}</span></p>
                        </div>

                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-3'>
                            <p> <ReduceCapacityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Maximum Capacity :</b>&nbsp;<span>{data?.maxCapicity}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p><ReduceCapacityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Minimum Capacity :</b>&nbsp;<span>{data?.minCapicity}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BirthadayClubingTTK